import React from "react";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import { Trash2, Download, ShieldCheck } from "lucide-react";

const SelectionInfoBanner = ({ ctx }) => {
  return (
    <div>
      {ctx.selectedContacts.length > 0 && (
        <div
          role="status"
          aria-live="polite"
          className="mt-1.5 rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-2 py-2 shadow-custom-light"
        >
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
            <div className="flex min-w-0 flex-1 flex-wrap items-start gap-y-2">
              <div className="flex min-w-0 items-center gap-3">
                <p className="text-xs font-medium leading-snug text-gray-900 dark:text-gray-100 flex items-center">
                  {ctx.allContactsOnPageSelected &&
                  ctx.selectedContacts.length === ctx.displayContacts.length ? (
                    <>
                      Current page fully selected
                      <span className="ml-0.5 tabular-nums text-gray-500">
                        ({ctx.displayContacts.length}).
                      </span>
                    </>
                  ) : (
                    <div className="flex items-center">
                      <span className="tabular-nums mr-0.5">
                        {ctx.selectedContacts.length.toLocaleString()}
                      </span>{" "}
                      Contact
                      {ctx.selectedContacts.length !== 1 ? "s" : ""} selected
                      {ctx.selectedContacts.length >=
                        ctx.contactsSelectionLimit && (
                        <span className="ml-1 font-normal text-gray-500">
                          (maximum batch size).
                        </span>
                      )}
                    </div>
                  )}
                </p>
              </div>
              {ctx.maxSelectableFromFilteredList >
                ctx.selectedContacts.length && (
                <>
                  <button
                    type="button"
                    className="self-center text-left text-xs font-medium text-secondary underline-offset-2 transition-colors hover:text-secondary-light hover:underline ml-1"
                    onClick={ctx.selectEntireFilteredList}
                  >
                    {ctx.totalContacts > ctx.contactsSelectionLimit ? (
                      <>
                        Select up to{" "}
                        <span className="tabular-nums">
                          {ctx.contactsSelectionLimit.toLocaleString()}
                        </span>{" "}
                        contacts
                        <span className="ml-1 font-normal text-gray-500">
                          (
                          <span className="tabular-nums">
                            {ctx.totalContacts.toLocaleString()}
                          </span>{" "}
                          match)
                        </span>
                      </>
                    ) : (
                      <>
                        Select all{" "}
                        <span className="tabular-nums">
                          {ctx.totalContacts.toLocaleString()}
                        </span>{" "}
                        contact
                        {ctx.totalContacts !== 1 ? "s" : ""} in this list
                      </>
                    )}
                  </button>
                </>
              )}
            </div>

            <div className="flex shrink-0 flex-wrap items-center justify-end gap-2 border-t border-gray-100 dark:border-gray-800 pt-3 sm:border-0 sm:pt-0">
              {ctx.selectedContacts.length > 0 && (
                <>
                  <SecondaryButton
                    title={`Export (${ctx.selectedContacts.length})`}
                    icon={<Download size={16} className="text-secondary" />}
                    onClick={ctx.handleExportSelected}
                    className="shadow-none border-secondary text-secondary bg-secondary/5"
                  />
                  <SecondaryButton
                    title={`Delete (${ctx.selectedContacts.length})`}
                    icon={<Trash2 size={16} className="text-error-500" />}
                    onClick={() => ctx.setShowDeleteConfirmModal(true)}
                    className="shadow-none border-error-500 text-error-500"
                    disabled={ctx.isBulkDeleting}
                    isLoading={ctx.isBulkDeleting}
                  />
                  <SecondaryButton
                    title={`Update consent (${ctx.selectedContacts.length})`}
                    icon={<ShieldCheck size={16} className="text-secondary" />}
                    onClick={() => ctx.openConsentUpdate()}
                    className="shadow-none border-secondary text-secondary bg-secondary/5"
                    disabled={ctx.isUpdatingConsent}
                  />
                </>
              )}
              <SecondaryButton
                title="Clear selection"
                onClick={ctx.clearSelection}
                className="shadow-none"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectionInfoBanner;
